export default __webpack_public_path__ + "static/media/kadra_milosz.046bd9fa.jpeg";